export default "__VITE_ASSET__Dyy4J5CZ__"